import classNames from "classnames";
import styles from "./index.module.less";

const ProductCard = ({
  name = "数字员工企业版",
  value = "enterprise",
  desc,
  icon,
  img,
  isActive = false,
  onClick = () => {},
}: {
  name: string;
  value: string;
  desc: string;
  icon?: any;
  img?: any;
  isActive?: boolean;
  onClick?: () => void;
}) => {
  return (
    <div className={classNames(styles.card, { [styles.active]: isActive })}>
      <div className={styles.img}>
        <img src={img} />
      </div>
      <div className={styles.content}>
        <div className={styles.name}>{name}</div>
        <div className={styles.desc}>{desc}</div>
      </div>
      <div className={styles.icon}>
        <img src={icon} />
      </div>
    </div>
  );
};
export default ProductCard;
